module.exports = __webpack_public_path__ + "static/img/icon4.10a6b14a.png";